export class DocNote {
  docId: string;
  docNoteId: string;
  docNoteTitle: string;
  docNote: string;
  pageNumber: number;
  isPrivate: boolean;
  createdById: string;
  dateTimeCreated: string;
  author: string;
}
